<template>
    <div id="TableSandbox">
        <div class="header">
            <div class="header-icon">
                <i class="material-icons">delete_outline</i>
            </div>
            <div class="header-text">
                <h1>Tablo Silinen Senaryolar</h1>
                <p>Silinen tablolarınız çöp sepetinde 30 gün bekledikten sonra otomatik olarak silinir</p>
            </div>
        </div>

        <div v-if="loading" class="tables-loading">
            <div v-for="skltn in 3" class="table table-skeleton" :key="skltn">
                <a-skeleton :active="true" :paragraph="{ rows: 3 }" />
            </div>
        </div>

        <div v-else-if="deletedTables.length === 0" class="empty-state">
            <i class="material-icons">delete_outline</i>
            <p>Çöp sepetinde silinen tablo bulunmuyor</p>
        </div>

        <div v-else class="tables">
            <div
                class="table table-deleted"
                v-for="table in deletedTables"
                :key="table._id || table.id"
            >
                <div class="table-header">
                    <div class="table-title">{{ table.name || "İsimsiz Tablo" }}</div>
                    <a-popover trigger="click" class="table-menu-content">
                        <div slot="content">
                            <div
                                class="table-menu-popover-items"
                                @click="restoreTable(table)"
                            >
                                <span><a-icon type="undo" class="px-1" /></span>
                                <span>Geri Yükle</span>
                            </div>
                            <div
                                class="table-menu-popover-items danger-item"
                                @click="permanentlyDeleteTable(table)"
                            >
                                <span><a-icon type="delete" class="px-1" /></span>
                                <span>Kalıcı Olarak Sil</span>
                            </div>
                        </div>
                        <a-button
                            class="table-menu-btn"
                            @click="(e) => e.stopPropagation()"
                        >
                            <span class="material-icons">more_vert</span>
                        </a-button>
                    </a-popover>
                </div>
                <div class="table-content">
                    <div class="table-description" v-if="table.description">
                        {{ table.description }}
                    </div>
                    <div class="table-meta">
                        <div class="meta-item">
                            <i class="material-icons">schedule</i>
                            <span>{{ formatDeletedDate(table.trashedAt) }}</span>
                        </div>
                        <div class="meta-item" v-if="table.trashedBy">
                            <i class="material-icons">person</i>
                            <span>{{ getDeletedByText(table.trashedBy) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { TABLE_API } from "../../../api/table";
import moment from "moment";

export default {
    name: "TableSandbox",
    data() {
        return {
            loading: true,
            deletedTables: [],
        };
    },
    methods: {
        formatDeletedDate(trashedAt) {
            if (!trashedAt) return "Bilinmiyor";
            return moment(trashedAt).format("DD.MM.YYYY HH:mm");
        },
        getDeletedByText(trashedBy) {
            if (!trashedBy) return "Bilinmiyor";
            if (typeof trashedBy === "object" && trashedBy.name) {
                return trashedBy.name;
            }
            if (typeof trashedBy === "object" && trashedBy.email) {
                return trashedBy.email;
            }
            return "Kullanıcı";
        },
        async restoreTable(table) {
            this.$confirm({
                title: "Tabloyu Geri Yüklemek İstediğinize Emin Misiniz?",
                content: `${table.name} tablosu geri yüklenecek.`,
                okText: "Evet",
                okType: "primary",
                cancelText: "Hayır",
                onOk: async () => {
                    try {
                        await TABLE_API.restoreTable(table._id || table.id);
                        this.$message.success("Tablo geri yüklendi");
                        // Silinen tablolar listesini güncelle
                        await this.loadDeletedTables();
                        // Ana tablo listesini güncelle (store'u güncellemek için - delay 0 ile anında çalışır)
                        await this.$store.dispatch("table/syncTables", 0);
                    } catch (error) {
                        console.error("Restore error:", error);
                        this.$message.error(error.response?.data?.error || "Geri yükleme başarısız oldu");
                    }
                },
            });
        },
        async permanentlyDeleteTable(table) {
            this.$confirm({
                title: "Tabloyu Kalıcı Olarak Silmek İstediğinize Emin Misiniz?",
                content: `${table.name} tablosu kalıcı olarak silinecek. Bu işlem geri alınamaz.`,
                okText: "Evet, Kalıcı Olarak Sil",
                okType: "danger",
                cancelText: "İptal",
                onOk: async () => {
                    try {
                        await TABLE_API.permanentlyDeleteTable(table._id || table.id);
                        this.$message.success("Tablo kalıcı olarak silindi");
                        await this.loadDeletedTables();
                    } catch (error) {
                        console.error("Permanent delete error:", error);
                        this.$message.error(error.response?.data?.error || "Kalıcı silme başarısız oldu");
                    }
                },
            });
        },
        async loadDeletedTables() {
            try {
                this.loading = true;
                const data = await TABLE_API.listDeletedTables();
                this.deletedTables = data || [];
            } catch (error) {
                console.error("Load deleted tables error:", error);
                this.$message.error("Silinen tablolar yüklenirken hata oluştu");
                this.deletedTables = [];
            } finally {
                this.loading = false;
            }
        },
    },
    async mounted() {
        await this.loadDeletedTables();
    },
};
</script>
<style lang="scss" scoped>
#TableSandbox {
    width: 100%;
    padding: 1.5rem;
    box-sizing: border-box;

    .header {
        display: flex;
        align-items: flex-start;
        padding: 1.5rem;
        background: #ffffff;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        margin-bottom: 1.5rem;
        width: 100%;
        box-sizing: border-box;

        .header-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background: #f3f4f6;
            border-radius: 6px;
            margin-right: 1rem;
            flex-shrink: 0;

            .material-icons {
                font-size: 20px;
                color: #6b7280;
            }
        }

        .header-text {
            flex: 1;
            min-width: 0;

            h1 {
                font-size: 1.25rem;
                font-weight: 600;
                color: #111827;
                margin: 0 0 0.5rem 0;
            }

            p {
                font-size: 0.875rem;
                color: #6b7280;
                margin: 0;
                line-height: 1.5;
            }
        }
    }

    .tables-loading {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;

        .table-skeleton {
            width: 280px;
            height: 200px;
            background: #ffffff;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            padding: 1rem;
        }
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 4rem 2rem;
        background: #ffffff;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        text-align: center;

        .material-icons {
            font-size: 64px;
            color: #d1d5db;
            margin-bottom: 1rem;
        }

        p {
            font-size: 1rem;
            color: #6b7280;
            margin: 0;
        }
    }

    .tables {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;

        .table {
            background: #ffffff;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            width: 280px;
            min-width: 250px;
            max-width: 280px;
            display: flex;
            flex-direction: column;
            transition: all 0.2s;
            position: relative;

            &:hover {
                box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                border-color: #d1d5db;
            }

            &.table-deleted {
                opacity: 0.85;
                border-left: 3px solid #ef4444;
            }

            .table-header {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding: 1rem 1rem 0.5rem 1rem;
                border-bottom: 1px solid #f3f4f6;

                .table-title {
                    font-size: 1rem;
                    font-weight: 600;
                    color: #111827;
                    flex: 1;
                    margin-right: 0.5rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .table-menu-btn {
                    border: none;
                    background: transparent;
                    padding: 0.25rem;
                    min-width: auto;
                    height: auto;
                    box-shadow: none;

                    .material-icons {
                        font-size: 20px;
                        color: #6b7280;
                    }

                    &:hover {
                        background: #f3f4f6;
                    }
                }
            }

            .table-content {
                padding: 1rem;
                flex: 1;
                display: flex;
                flex-direction: column;

                .table-description {
                    font-size: 0.875rem;
                    color: #6b7280;
                    margin-bottom: 1rem;
                    line-height: 1.5;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                .table-meta {
                    margin-top: auto;
                    padding-top: 0.75rem;
                    border-top: 1px solid #f3f4f6;
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;

                    .meta-item {
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;
                        font-size: 0.75rem;
                        color: #9ca3af;

                        .material-icons {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}

.table-menu-popover-items {
    padding: 8px 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        color: #1890ff;
        background: #f0f7ff;
    }
    
    &.danger-item {
        color: #ff4d4f;
        &:hover {
            background-color: #fff1f0;
            color: #cf1322;
        }
    }
}
</style>
